import React from 'react';

/**
 * “Price dropped” typography: old price struck through, new price emphasised.
 * e.g. <StruckPrice oldPrice="₹51" newPrice="₹21" /> → ~~₹51~~ ₹21
 */
export default function StruckPrice({ oldPrice, newPrice, className = '' }) {
  return (
    <span className={className}>
      <s style={{ opacity: 0.62, textDecorationThickness: '1.5px', textDecorationColor: 'currentColor' }}>
        {oldPrice}
      </s>
      {' '}
      <strong>{newPrice}</strong>
    </span>
  );
}
